import React from 'react'
import styles from './FormPage.module.css'
import Header from '../../sections/Header'
import VerticalEntryForm from '../VerticalEntryForm'
import { FormPageProps } from './types'
import { StepProvider } from '@/components/Context/StepContext'

const formPageConfig = {
    stepFormLabels: {
        step1: {
            dataViewLabel: 'Register_EF_StepForm_Step1-現在の状況',
            dataClickLabels: {
                working: 'Register_EF_StepForm_Step1-現在の状況-在籍中',
                unemployed: 'Register_EF_StepForm_Step1-現在の状況-離職中',
            }
        },
        step2: {
            dataViewLabel: 'Register_EF_StepForm_Step2-経験年数',
            dataClickLabels: {
                lessThan1: 'Register_EF_StepForm_Step2-経験年数-1年未満',
                oneToFive: 'Register_EF_StepForm_Step2-経験年数-1~5年',
                fiveToTen: 'Register_EF_StepForm_Step2-経験年数-5~10年',
                moreThan10: 'Register_EF_StepForm_Step2-経験年数-10年以上',
                back: 'Register_EF_StepForm_Step2-経験年数-戻る'
            }
        },
        step3: {
            dataViewLabel: 'Register_EF_StepForm_Step3-お住まい',
            dataClickLabels: {
                back: 'Register_EF_StepForm_Step3-お住まい-戻る',
                next: 'Register_EF_StepForm_Step3-お住まい-次へ'
            }
        },
        step4: {
            dataViewLabel: 'Register_EF_StepForm_Step4-名前年齢',
            dataClickLabels: {
                back: 'Register_EF_StepForm_Step4-名前年齢-戻る',
                next: 'Register_EF_StepForm_Step4-名前年齢-次へ'
            }
        },
        step5: {
            dataViewLabel: 'Register_EF_StepForm_Step5-連絡先',
            dataClickLabels: {
                back: 'Register_EF_StepForm_Step5-連絡先-戻る',
                link: 'Register_EF_StepForm_Step5-連絡先-Link-利用規約',
                cta: 'Register_EF_StepForm_Step5-連絡先-CVボタン',
                lineCheckbox: 'Register_EF_StepForm_Step5-連絡先-LINEチェック'
            }
        },
    }
}

const FormPage = ({ prefectures }: FormPageProps) => {
    return (
        <section>
            <div className={styles.FormPageWrap}>
                <div className={styles.headerWrap}>
                    <Header id='top' dataViewLabel='Register' />
                </div>
                <div className={styles.formWrap}>
                    <StepProvider
                        initialFormData={{
                            preferLineContact: true,
                            agreeTerms: true
                        }}
                        initialTouchedFields={{
                            preferLineContact: true,
                            agreeTerms: true,
                            channel: true
                        }}
                    >
                        <VerticalEntryForm
                            prefectures={prefectures}
                            config={formPageConfig}
                    />
                    </StepProvider>
                </div>
            </div>
        </section>
    )
}

export default FormPage
